import { Checkbox as MuiCheckbox } from "@mui/material";
import { forwardRef } from "react";

export default forwardRef(function Checkbox(props, ref) {
  return <MuiCheckbox {...props} color="light" ref={ref} />;
});
